module.exports = {
  SyncGMInfo: "SyncGMInfo",
  SyncGMScore: "SyncGMScore",
  SyncUserInfo: "SyncUserInfo",
  SyncUserScore: "SyncUserScore",
  SyncToken: "SyncToken",
  SyncBonus: "SyncBonus",
  SyncBonusBroadcast: "SyncBonusBroadcast",
};
